import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { TenderTimeContext } from "./TenderTimeContext";
import { useCapturedServerTime } from "../hooks/useCapturedServerTime";
import serverClock from "../services/serverClock";

export const TenderTimeProvider = ({ sessionKey, enabled = true, children }) => {
  const clock = useCapturedServerTime(enabled, sessionKey);
  const tokenRef = useRef(null);
  if (tokenRef.current?.key !== sessionKey || tokenRef.current?.enabled !== enabled) {
    tokenRef.current = { key: sessionKey, enabled };
  }
  const token = tokenRef.current;
  const mounted = useRef(false);
  const [refreshedTime, setRefreshedTime] = useState(null);
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  const value = {
    clock: refreshedTime?.token === token ? { ...clock, nowMs: refreshedTime.nowMs, isReady: true } : clock,
    token,
    isCurrent: () => mounted.current && tokenRef.current === token,
    refreshTime: async () => {
      const nowMs = await serverClock.ensureTime();
      if (nowMs != null && mounted.current && tokenRef.current === token) {
        setRefreshedTime({ token, nowMs });
      }
    },
  };
  return <TenderTimeContext.Provider value={value}>{children}</TenderTimeContext.Provider>;
};

// The scope must sit above the root's own tender-state hooks as well as its children.
export const withTenderTime = (Component) => {
  const TenderCard = (props) => {
    const companyId = useSelector((state) => state.user?.companyId ?? state.user?.company?.id);
    const enabled = props.isOpen !== false && props.orderId != null;
    const sessionKey = JSON.stringify([props.orderId, companyId, enabled]);
    return (
      <TenderTimeProvider sessionKey={sessionKey} enabled={enabled}>
        <Component {...props} />
      </TenderTimeProvider>
    );
  };
  TenderCard.displayName = `WithTenderTime(${Component.displayName || Component.name})`;
  return TenderCard;
};
